import { render, staticRenderFns } from "./left.vue?vue&type=template&id=2b011357&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=2b011357&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b011357",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b011357')) {
      api.createRecord('2b011357', component.options)
    } else {
      api.reload('2b011357', component.options)
    }
    module.hot.accept("./left.vue?vue&type=template&id=2b011357&scoped=true", function () {
      api.rerender('2b011357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/system/quick/components/left.vue"
export default component.exports